"use client";

import { useEffect, useState } from "react";
import type { LandingData } from "./types";

const LANDING_JSON_URL = "/onboarding/landing.json";

export const useLandingData = () => {
	const [data, setData] = useState<LandingData | null>(null);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		let cancelled = false;
		fetch(LANDING_JSON_URL)
			.then((res) => {
				if (!res.ok)
					throw new Error(`Failed to load landing data: ${res.status}`);
				return res.json() as Promise<LandingData>;
			})
			.then((d) => {
				if (!cancelled) setData(d);
			})
			.catch((e) => {
				if (!cancelled) setError(e instanceof Error ? e : new Error(String(e)));
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return { data, error };
};
